export function analysisSubmission({ create, lookup, storage, storageKey, onState, onRun }) {
  let pending = null, busy = false
  try { pending = JSON.parse(storage?.getItem(storageKey) || 'null') } catch {}
  if (!pending?.idempotency_key || !pending?.profile_hash || !pending?.expected_profile_revision) pending = null
  const state = value => onState(value)
  function remember(body) {
    pending = body
    try {
      if (body) storage?.setItem(storageKey, JSON.stringify(body))
      else storage?.removeItem(storageKey)
    } catch { /* In-memory identity still protects this page if storage is unavailable. */ }
  }
  function accepted(run) {
    onRun(run)
    remember(null)
    state('accepted')
  }
  async function lookupPending() {
    state('confirming')
    try {
      const run = await lookup(pending.idempotency_key)
      if (run?.id) { accepted(run); return }
    } catch { /* Read failure is not evidence that creation failed. */ }
    state('unconfirmed')
  }
  if (pending) state('unconfirmed')
  return {
    hasPending: () => Boolean(pending),
    async confirm() {
      if (!pending || busy) return
      busy = true
      try { await lookupPending() } finally { busy = false }
    },
    async start(body) {
      if (busy) return
      busy = true
      remember(pending || body)
      state('submitting')
      try { accepted(await create(pending)) }
      catch (error) {
        if (error?.status >= 400 && error.status < 500 && ![408, 425, 429].includes(error.status)) {
          remember(null)
          state('rejected')
          throw error
        }
        await lookupPending()
      } finally { busy = false }
    },
  }
}
